import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getFirestore } from 'firebase/firestore';

// Replace these with your actual Firebase config from the console
const firebaseConfig = {
  apiKey: "AIzaSyD4hHjmaU3lwe90FUF9oIN-TwNqWAuAmcQ",
  authDomain: "mobidawg-native-db.firebaseapp.com",
  databaseURL: "https://mobidawg-native-db-default-rtdb.firebaseio.com",
  projectId: "mobidawg-native-db",
  storageBucket: "mobidawg-native-db.appspot.com",
  messagingSenderId: "1041202901077",
  appId: "G-1D4PEXW6RV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const rtdb = getDatabase(app);
